import React from 'react'
import Icon from '@ant-design/icons'
import { ServiceIcon as SharedIcon } from 'components/Icon/ContactIcons'

export default (props) => {
  const { color = '#919191' } = props
  const SvgIcon = () => <SharedIcon color={color || 'currentColor'} />
  return <Icon component={SvgIcon} {...props} />
}
